import api from "../api";
import {
  FETCH_ENTITY_RELATIONS_BEGIN,
  FETCH_ENTITY_RELATIONS_SUCCESS,
  FETCH_ENTITY_RELATIONS_FAILURE,
  FETCH_USER_RELATIONS_SUCCESS,
  FETCH_USER_RELATIONS_BEGIN,
  FETCH_USER_RELATIONS_FAILURE
} from "../types";

export const fetchEntityRelationsBegin = () => ({
  type: FETCH_ENTITY_RELATIONS_BEGIN
});

export const fetchEntityRelationsSuccess = data => ({
  type: FETCH_ENTITY_RELATIONS_SUCCESS,
  data
});

export const fetchEntityRelationsFailure = error => ({
  type: FETCH_ENTITY_RELATIONS_FAILURE,
  error
});

export const getEntityRelationsList = input => dispatch => {
  dispatch(fetchEntityRelationsBegin());

  return api.relations
    .relationsByEntity(input)
    .then(resp => {
      dispatch(fetchEntityRelationsSuccess(resp));
      return resp.data;
    })
    .catch(error => dispatch(fetchEntityRelationsFailure(error)));
};

export const getEntityUserRelationsList = input => dispatch => {
  dispatch(fetchUserRelationsBegin());
  // let resp = await api.relations.relationsByEntityUser(input);
  // if (resp) {
  //   dispatch(fetchUserRelationsSuccess(resp));
  //   return resp;
  // } else {
  //   dispatch(fetchUserRelationsFailure({ error: "error" }));
  // }
  return api.relations
    .relationsByEntityUser(input)
    .then(resp => {
      dispatch(fetchUserRelationsSuccess(resp));
      return resp.data;
    })
    .catch(error => dispatch(fetchUserRelationsFailure(error)));
};

export const fetchUserRelationsBegin = () => ({
  type: FETCH_USER_RELATIONS_BEGIN
});
export const fetchUserRelationsSuccess = data => {
  return {
    type: FETCH_USER_RELATIONS_SUCCESS,
    data
  };
};

export const fetchUserRelationsFailure = error => ({
  type: FETCH_USER_RELATIONS_FAILURE,
  error
});

export const getUserRelationsList = input => dispatch => {
  dispatch(fetchUserRelationsBegin());
  return api.relations
    .relationsByUser(input)
    .then(resp => dispatch(fetchUserRelationsSuccess(resp)))
    .catch(error => dispatch(fetchUserRelationsFailure(error)));
};
